import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";


@Component({
  selector: 'app-dynamic-search',
  templateUrl: './dynamic-search.component.html',
  styleUrls: ['./dynamic-search.component.scss']
})
export class DynamicSearchComponent {
  @Output() searchEvent = new EventEmitter<any>();
  searchForm: FormGroup;
  appliedFilters: { name: string, value: string, values?:any}[] = [];

  private _defaultFilters: any = undefined;
  private _filters: any = {};
  @Input()  set filters(value: any) {
    this._defaultFilters ??= value;
    this._filters = value;
  }
  get filterOptions(): any {
    return this._filters;
  }

  constructor(private formBuilder: FormBuilder) {
    this.searchForm = this.formBuilder.group({
      selectedFilter: [''],
      filterValue: ['']
    });

    this.searchForm.controls['selectedFilter'].valueChanges.subscribe((value: any) => {
      this.selectedFilter = this.filterOptions.find((item: any) => {
        return item.name === this.searchForm.controls['selectedFilter'].value;
      });
    });
  }

  onSearch() {
    const selectedFilter = this.searchForm.controls['selectedFilter'].value;
    const filterValue = this.searchForm.controls['filterValue'].value;

    if (selectedFilter && filterValue) {
      const newFilter = { name: selectedFilter, value: filterValue, values: this.selectedFilter.values };
      this.appliedFilters.push(newFilter);

      this.filters = this._filters.filter((item: any) => {
        return item.name !== selectedFilter;
      });
      this.searchEvent.emit({ filters: this.appliedFilters });
      console.log(this.appliedFilters);
      this.searchForm.reset();
      this.searchForm.controls['selectedFilter'].setValue(this._filters[0].name);
    }
    else {
      console.log(selectedFilter, filterValue)
    }
  }
  refreshFilters() {
    this.filters = this._defaultFilters;
    this.appliedFilters.forEach((filter: any) => {
      this.filters = this._filters.filter((item: any) => {
        return item.name !== filter.name;
      });
    });
    this.searchForm.controls['selectedFilter'].setValue(this._filters[0].name);
  }

  removeFilter(index: number) {
    this.appliedFilters.splice(index, 1);
    this.refreshFilters();
    this.searchEvent.emit({ filters: this.appliedFilters });
  }

  selectedFilter: any;
}
